<div class="flex items-center justify-center w-full  h-full">
  <div class="antialiased sans-serif w-full">
    <div>
      <div class="w-full">
        <div class="mb-5 w-full">
          <div class="relative flex flex-col gap-4 w-full">
            <input type="hidden" name="date" x-ref="date" />
            @if (showInput) {
            <!-- Même champ que les autres saisies des feuilles (bordure vw-line-strong). -->
            <input type="text" readonly [(ngModel)]="datepickerValue" (click)="showDatepicker = !showDatepicker"
              (keydown.escape)="showDatepicker = false"
              class="min-h-btn w-full rounded-field border border-vw-line-strong bg-vw-surface px-3 text-body text-vw-ink focus:border-vw-primary focus:outline-none" />
            }
            <!-- <div {{no_of_days.length"></div>
                            <div {{32 - new Date(year, month, 32).getDate()"></div>
                            <div {{new Date(year, month).getDay()"></div> -->
            <div class="w-full px-4" [hidden]="!showDatepicker" (keydown.away)="showDatepicker = false">
              <div class="flex justify-between items-center mb-2">
                <!-- CURRENT MONTH AND YEAR -->
                <div>
                  <span class="text-title-s text-vw-ink">{{ 'common.months.' + (month+1) | translate }}</span>
                  <span class="ml-1 text-title-s font-normal text-vw-muted">{{ year }}</span>
                </div>
                <!-- NEXT / PREVIOUS MONTH -->
                <div>
                  <button type="button" class="inline-flex h-target w-target cursor-pointer items-center justify-center rounded-pill text-vw-muted transition duration-100 ease-in-out active:bg-vw-surface-sunk"
                    [attr.aria-label]="'common.previous-month' | translate" (click)="changeMonth(-1)">
                    <svg class="inline-flex h-6 w-6" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  <button type="button" class="inline-flex h-target w-target cursor-pointer items-center justify-center rounded-pill text-vw-muted transition duration-100 ease-in-out active:bg-vw-surface-sunk"
                    [ngClass]="{ 'cursor-not-allowed opacity-25': isNextMonthDisabled }"
                    [disabled]="isNextMonthDisabled" [attr.aria-label]="'common.next-month' | translate"
                    (click)="changeMonth(1)">
                    <svg class="inline-flex h-6 w-6" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>

              <!-- DAY NAMES -->
              <div class="flex flex-wrap mb-3 -mx-1">
                @for (day of DAYS_NUM; track day; let index = $index) {
                <div style="width: 14.26%" class="px-1">
                  <div class="text-center text-caption text-vw-muted">{{ 'common.days_short.' + day | translate
                    }}</div>
                </div>
                }
              </div>

              <div class="flex flex-wrap -mx-1">
                <!-- Cases vides -->
                @for (blankday of blankdays; track blankday) {
                <div style="width: 14.28%" class="min-h-10"></div>
                }

                <!-- Jours du mois -->
                @for (date of no_of_days; track trackByIdentity($index, date); let dateIndex = $index) {
                <div style="width: 14.28%" class="min-h-11 flex flex-col items-center">

                  <div (click)="getDateValue(date)" class="
          cursor-pointer
          text-center text-body-s
          w-full h-full
          flex items-center justify-center
          transition
          ease-in-out
          duration-100 rounded-full
        " [ngClass]="{
      'pointer-events-none opacity-30': isDisabled(date),
      'bg-vw-surface-tint font-semibold text-vw-primary-ink': isToday(date) && !isSelectedDate(date),
      'bg-vw-primary font-semibold text-vw-on-color': isSelectedDate(date),
      'text-vw-ink active:bg-vw-surface-sunk': !isToday(date) && !isSelectedDate(date)
    }">
                    {{ date }}
                  </div>
                </div>
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>